import { Dialog } from "@headlessui/react";
import { IKImage } from 'imagekitio-react';
import { useEffect } from "react";
import { useConfetti } from "../../../hooks/useConfetti";

export default function QuizPopup({ openModal, setOpenModal, heading, text, coinAmount }) {
    const [confettiRef, confetti] = useConfetti()

    useEffect(() => {
        if (openModal) {

            confetti()
        }

    }, [openModal])
    return (
        <div>
            <Dialog open={openModal}
                onClose={() => setOpenModal(false)}
                as="div"
                className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-28 w-full h-full justify-center flex-col items-center" >
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                <Dialog.Title />
                <Dialog.Description />
                <div ref={confettiRef} className="bg-white z-20 w-[80%] md:w-1/3 absolute top-1/4 md:top-20 py-5 px-3 rounded-lg flex flex-col justify-center items-center">
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src='https://assets.learntube.ai/files/Content_player/quizCompleteEmoji.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657260994143'
                        className="w-20 h-20 md:w-16 md:h-16"
                        transformation={[{
                            "height": "160",
                            "width": "160",
                        }]}
                    />
                    <h2 className="mt-6 mb-2 font-bold text-2xl">{heading}</h2>
                    <p className="text-center">{text}<br />You earn <span className="font-semibold text-amber-500">{coinAmount} coins.</span></p>
                    <button className="bg-[#FDBF48] md:w-40 font-semibold mt-6 rounded py-2.5 px-3 w-[90%]" onClick={() => setOpenModal(false)}>Got it!</button>
                </div>
            </Dialog>
        </div>
    )
}